module.exports = __webpack_public_path__ + "img/birthday-celebration.2b7f4ff3.webp";